/**
 * VETA CAR brand logo.
 * Resolves the PNG asset under /public/vetacar-logo.png served by CRA.
 */
export default function Logo({ size = 40, className = "", showText = false }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src="/vetacar-logo.png"
        alt="VETA CAR"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain" }}
        data-testid="vetacar-logo"
      />
      {showText && (
        <span className="font-display text-2xl tracking-tighter leading-none">VETA CAR</span>
      )}
    </span>
  );
}
